<script>
export default {
    name: "InsuranceInvoiceForm",

    data() {

        return {
            selectedInsurance: 0
        };
    },

    props: {

        insurances: Array,
        insuranceInvoice: Object,
        benefitPackages: Array,
        insuranceSchemes: Array,
        totalReceive: Number,
    },

    watch: {

        selectedInsurance() {
            if(!this.insurances.length) return;

            const selectedIns = this.insurances.filter(ins => ins.code == this.selectedInsurance);

            if(!selectedIns.length) return;

            this.insuranceInvoice.insurance = {
                organizationID: selectedIns[0].code,
                schemeId: selectedIns[0].schemeId,
                benefitPackageID: selectedIns[0].benefitPackageID
            };
        },
    },
}
</script>
<template>
<div class="flex flex-wrap">
    <div class="w-full overflow-auto">
        <table class="table">
            <thead class="bg-blue-500 text-xs text-white whitespace-no-wrap">
                <tr class="w-full flex">
                    <th class="p-tiny w-1/12">Code</th>
                    <th class="p-tiny flex-1">Organization</th>
                    <th class="p-tiny flex-1">Package</th>
                    <th class="p-tiny flex-1">Scheme</th>
                    <th class="p-tiny w-1/12">Select</th>
                </tr>
            </thead>
            <tbody 
                class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" 
                style="max-height:18vh;">
                <tr class="w-full flex" v-for="(ins,idx) in insurances" :key="idx">
                    <td class="p-tiny w-1/12">{{ ins.code }}</td>
                    <td class="p-tiny flex-1">
                        <h5 class="text-xs font-medium text-gray-600">
                            {{ ins.organization }}</h5>
                        <h5 class="text-xs font-medium text-gray-600">
                            Dependant: {{ ins.principal_Dependant}}</h5>
                        <h5 class="text-xs font-medium text-gray-600">
                            Member No: {{ ins.member_No }}</h5>
                            <h5 class="text-xs font-medium text-gray-600">
                            Limit : {{ ins.coverLimit?(ins.coverLimit|numberFormat):'-'}}</h5>
                    </td>
                    <td class="p-tiny flex-1">
                        <tail-select>
                            <template v-slot:field>
                                <select v-model="ins.benefitPackageID" @change="() => { 
                                        insuranceInvoice.insurance.benefitPackageID=ins.benefitPackageID
                                    }" class="input-control input-sm text-xs">
                                    <option :value="0">Select package</option>
                                    <option 
                                        v-for="(benefitPackage,idx) in benefitPackages" 
                                        :key="idx" :value="benefitPackage.packageId">
                                            {{ benefitPackage.packageName }}</option>
                                </select>
                            </template>
                        </tail-select>
                    </td>
                    <td class="p-tiny flex-1">
                        <tail-select>
                            <template v-slot:field>
                                <select v-model="ins.schemeId" @change="() => { 
                                        insuranceInvoice.insurance.schemeId=ins.schemeId;
                                    }" class="input-control input-sm text-xs">
                                    <option :value="0">Select scheme</option>
                                    <option
                                        v-for="(insuranceScheme,idx) in 
                                          insuranceSchemes.length && 
                                          insuranceSchemes.filter(scheme => scheme.organizationID==ins.code)"
                                        :key="idx" :value="insuranceScheme.schemeId">
                                            {{ insuranceScheme.schemeName }}</option>
                                </select>
                            </template>
                        </tail-select>
                    </td>
                    <td class="p-tiny w-1/12">
                        <label :for="`insurance_${idx}`">
                        <input type="radio"
                            :id="`insurance_${idx}`"
                            :value="ins.code"
                            v-model.number="selectedInsurance">
                            {{ totalReceive }}
                        </label>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="md:w-2/3 sm:w-full p-tiny">
        <label for="grid-memo" class="label-control">Memo:</label>
        <input type="text" 
            v-model.trim="insuranceInvoice.memo" 
            id="grid-memo" class="input-control input-sm text-xs">
    </div>
</div>
</template>